import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { getSettings } from '../../redux/actions/settingsActions';
import { useAppThunkDispatch } from '../../redux/configureStore';
import { selectAccountId } from '../../redux/selectors/accountSelectors';
import NavigationBar from './NavigationBar';

const DashboardPage: React.FC = () => {
  const dispatch = useAppThunkDispatch();
  const accoundGuid = useSelector(selectAccountId);

  useEffect(() => {
    //load the company wide settings
    dispatch(getSettings(accoundGuid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={3} sx={{ flexDirection: 'column' }}>
      <Grid size={3}>
        <NavigationBar />
      </Grid>
      <Grid size="grow" sx={{ mt: '64px', ml: '240px' }}>
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default DashboardPage;
